import { isValidElement as f, cloneElement as h } from "react";
import { useThemeUI as u } from "theme-ui";
import * as r from "@radix-ui/react-collapsible";
import { useDerivedState as x } from "@material-bank/ds-utils";
import { jsxs as O, jsx as j } from "theme-ui/jsx-runtime";
const S = (l) => {
  const {
    CollapsibleTrigger: e,
    defaultOpen: p,
    open: s,
    onOpenChange: m,
    triggerPosition: n = "beforeContent",
    disabled: o,
    disableAnimation: t,
    children: c,
    contentSx: d,
    ...C
  } = l, {
    theme: g
  } = u(), [i, b] = x({
    value: s,
    initialValue: p,
    onChange: m
  }), a = f(e) && h(e, {
    open: i,
    disabled: o,
    ...e.props
  });
  return /* @__PURE__ */ O(r.Root, {
    ...C,
    disabled: o,
    open: i,
    onOpenChange: b,
    children: [n === "beforeContent" && a, /* @__PURE__ */ j(r.Content, {
      sx: {
        ...g.collapsibleContent,
        ...t && {
          '&[data-state="open"]': {
            animation: "none"
          }
        },
        ...t && {
          '&[data-state="closed"]': {
            animation: "none"
          }
        },
        ...d
      },
      children: c
    }), n === "afterContent" && a]
  });
};
export {
  S as Collapsible
};
